import { FormControl, FormLabel } from '@mui/material';

import { i18nt } from '../../../../../../../root';
import { NSPS_STUDY } from '../../../../../../../services/i18n/namespaces';

import CheckboxSelect from './CheckboxSelect';
import RadioSelect from './RadioSelect';

const singleSelectTypes = ['E_SOURCE', 'INTERNAL_PROJECT'];

export default function SelectGroup({ group, selectedTypeIds, setSelectedTypeIds, studyType }) {
  const { typeParent } = group;
  return (
    <FormControl fullWidth sx={{ mb: 2 }}>
      <FormLabel id={typeParent + '_LABEL_ID'}>{getLabel(typeParent)}</FormLabel>
      {singleSelectTypes.includes(typeParent) ? (
        <RadioSelect group={group} selectedTypeIds={selectedTypeIds} setSelectedTypeIds={setSelectedTypeIds} />
      ) : (
        <CheckboxSelect
          group={group}
          selectedTypeIds={selectedTypeIds}
          setSelectedTypeIds={setSelectedTypeIds}
          studyType={studyType}
        />
      )}
    </FormControl>
  );
}

function getLabel(typeParent) {
  return (
    i18nt(`studyType.groups.${typeParent}`, { ns: NSPS_STUDY }) +
    (typeParent === 'E_SOURCE'
      ? ` ${i18nt('studyType.modal.identifier', { ns: NSPS_STUDY })} (${i18nt(
          'studyType.modal.requiredForEsourceStudyType',
          {
            ns: NSPS_STUDY
          }
        )})`
      : ` ${i18nt('studyType.modal.identifier', { ns: NSPS_STUDY })}`)
  );
}
